export const numberBoxSx = {
    headerStack: {
        my: 4,
    },
}